import { API } from '@/config/api';
import React, { useState, useEffect } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Archive, ArchiveRestore } from 'lucide-react';
import { toast } from 'sonner';


export default function ArchivedVials() {
  const [vials, setVials] = useState([]);

  useEffect(() => {
    fetchVials();
  }, []);

  const fetchVials = async () => {
    try {
      const response = await fetch(`${API}/vials/archived`, {
        credentials: 'include'
      });
      if (response.ok) {
        setVials(await response.json());
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
    }
  };

  const handleUnarchive = async (vialId) => {
    try {
      const response = await fetch(`${API}/vials/${vialId}/unarchive`, {
        method: 'PUT',
        credentials: 'include'
      });

      if (response.ok) {
        toast.success('Vial unarchived');
        fetchVials();
      }
    } catch (error) {
      toast.error('Failed to unarchive vial');
    }
  };

  return (
    <div className="p-4 md:p-8 max-w-4xl mx-auto">
      <div className="flex items-center gap-3 mb-8">
        <Archive className="h-8 w-8 text-primary" />
        <h1 className="text-4xl font-bold">Archived Vials</h1>
      </div>

      {vials.length === 0 ? (
        <Card className="p-8 text-center text-muted-foreground glass-card">
          No archived vials
        </Card>
      ) : (
        <div className="space-y-3">
          {vials.map((vial) => (
            <Card key={vial.vial_id} className="p-6 glass-card">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-xl font-bold">{vial.peptide_name}</h3>
                  <p className="text-sm text-muted-foreground">
                    Batch: {vial.batch_number || 'N/A'}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    Archived: {new Date(vial.archived_at).toLocaleDateString()}
                  </p>
                </div>
                <Button
                  onClick={() => handleUnarchive(vial.vial_id)}
                  variant="outline"
                  size="sm"
                >
                  <ArchiveRestore className="h-4 w-4 mr-2" />
                  Unarchive
                </Button>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
